import React, { useEffect, useState } from "react";
import TextInput from "../components/TextInput";
import Button from "../components/Button";
import SelectText from "../components/SelectText";
import Flag from "../assets/img/flag.svg";
import { useNavigate } from "react-router-dom";
import { usePost } from "../hooks";
import { fireGenericErrorModal, /* firePostSuccessModal */ } from "../utils/swals";
import { SignIn } from "../utils/auth";
import banderasPaises from '../banderasPaises.json'
import { usePartido } from "../context/PartidoContext";

const FormularioNoVerificado = () => {
  const [tiposDeMedio, setTipoDeMedio] = useState();
  const [codPais, setCodPais] = useState();
  const [paises, setPaises] = useState();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombrePrograma: "",
    nombreMedio: "",
    tipoMedio: "",
    pais: "",
    provincia: "",
    datosContacto: {
      nombre: "",
      DNI: "",
      funcion: "",
      codArea: "",
      telefono: "",
      email: "",
    },
  });
  const { postJson, isLoading, error } = usePost(false);
  const { selectedPartido, setSelectedPartido } = usePartido();

  const handleSubmit = async () => {
    const result = await postJson("/registrar-medio-n", {
      tipoDeMedio: form.tipoMedio,
      pais: form.pais,
      provincia: form.provincia,
      nombre: form.nombreMedio,
      nombrePrograma: form.nombrePrograma,
      personal: [
        {
          nombre: form.datosContacto.nombre,
          dni: form.datosContacto.DNI,
          celular:
            form.datosContacto.codArea + " " + form.datosContacto.telefono,
          cargo: form.datosContacto.funcion,
          mail: form.datosContacto.email,
        },
      ],
    });

    if (result.status === "KO") {
      fireGenericErrorModal();
      console.log(error)
    } else {
      // El segundo parametro = true es para senalizar que no es verificado.
      SignIn(result.token, { isNV: true });
      if (selectedPartido) {
        const { id } = selectedPartido;
        setSelectedPartido(null);
        navigate(`/sumar-acreditaciones/${id}`);
      } else {
        navigate("/");
      }
    }
  };

  const updateForm = (field, event, isContacto = false) => {
    if (!isContacto) {
      setForm((prevState) => ({
        ...prevState,
        [field]: event.target ? event.target.value : event.value,
      }));
    } else {
      setForm((prevState) => ({
        ...prevState,
        datosContacto: {
          ...prevState.datosContacto,
          [field]: event.target ? event.target.value : event.value,
        },
      }));
    }
  };

  const isComplete =
    Object.values(form).every(Boolean) &&
    Object.values(form.datosContacto).every(Boolean);

  useEffect(() => {
    const fetchLocalJSON = async (url) => {
      const res = await fetch(url);
      const json = await res.json();
      return json;
    };

/*     const fetchCodigosPais = async () => {
      const res = await fetch(
        "https://restcountries.com/v3.1/all?fields=name,flags,cca3"
      );
      const json = await res.json();
        // Move Argentina to the beginning of the list
      const sortedData = json.sort((a, b) => {
        if (a.cca3 === "ARG") return -1; // Move Argentina (cca3: "ARG") to the top
        if (b.cca3 === "ARG") return 1;
        return 0; // Keep the rest of the items in their original order
      });
      return sortedData;
    };

    fetchCodigosPais().then((json) => setCodPais(json)); */

      // Sort banderasPaises locally, move ARG to top
    const sortedCodigos = [...banderasPaises].sort((a, b) => {
      if (a.cca3 === "ARG") return -1;
      if (b.cca3 === "ARG") return 1;
      return 0;
    });
    setCodPais(sortedCodigos);

    fetchLocalJSON("/data.json").then((json) => setTipoDeMedio(json.info));

    fetchLocalJSON("/paises.json").then((json) => setPaises(json));
  }, []);

  const codigosPais =
    codPais &&
    codPais.map((cod) => ({
      value: cod.cca3,
      label: (
        <div className="sel-label">
          <img src={cod.flags.svg} alt=''/>
          <span>{cod.cca3}</span>
        </div>
      ),
    }));

  const numerosPais =
    paises &&
    paises.map((pais) => ({
      value: `+${pais.phone_code}`,
      label: (
        <div className="sel-label">
          <span>+{pais.phone_code}</span>
          <span>{pais.nombre}</span>
        </div>
      ),
    }));

  return (
    <div className="bg-gray">
      <div className="nv-wrapper">
        <form className="nv-box">
          <h1>Completá el siguiente formulario</h1>
          <h6>Datos del medio</h6>
          <div className="nv-form">
            <TextInput
              placeholder={"Nombre del programa / transmisión"}
              onChange={(e) => updateForm("nombrePrograma", e)}
            />
            <SelectText
              placeholderText={"Nombre del medio"}
              selectPlaceholder={"Tipo de medio"}
              breaksInMobile
              options={tiposDeMedio}
              selectedOption={form.tipoMedio}
              setSelectedOption={(e) => updateForm("tipoMedio", e)}
              handleTextChange={(e) => updateForm("nombreMedio", e)}
            />
            <SelectText
              placeholderText={"Provincia / distrito / estado"}
              selectPlaceholder={
                <>
                  <img src={Flag} alt="" />
                  <span>País</span>
                </>
              }
              options={codigosPais}
              setSelectedOption={(e) => updateForm("pais", e)}
              handleTextChange={(e) => updateForm("provincia", e)}
              breaksInMobile
            />
          </div>
          <h6>Datos del contacto / Responsable del medio</h6>
          <div className="nv-form">
            <TextInput
              placeholder={"Nombre y apellido"}
              onChange={(e) => updateForm("nombre", e, true)}
            />
            <TextInput
              placeholder={"DNI o Pasaporte"}
              onChange={(e) => updateForm("DNI", e, true)}
              noDots={true}
              value={form.datosContacto.DNI || ""}
            /> 
            
            <TextInput
              placeholder={"Función"}
              onChange={(e) => updateForm("funcion", e, true)}
            />
            <div className="input-flex">
              <SelectText
                placeholderText={"Teléfono"}
                selectPlaceholder={
                  <>
                    <img src={Flag} alt="" />
                    <span>Cód. país</span>
                  </>
                }
                options={numerosPais}
                setSelectedOption={(e) => updateForm("codArea", e, true)}
                handleTextChange={(e) => updateForm("telefono", e, true)}
              />
              <TextInput
                placeholder={"Email"}
                onChange={(e) => updateForm("email", e, true)}
              />
            </div>
            <Button
              variant={`login-btn ${!isComplete || isLoading ? "" : "enabled"}`}
              onClick={handleSubmit}
              isDisabled={!isComplete || isLoading}
            >
              Ingresar
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormularioNoVerificado;
